import { Injectable } from '@angular/core';
import { MtrwfServicePkg } from './mtrwfPkg.service';

@Injectable({
  providedIn: 'root',
})
export class MtrwfService extends MtrwfServicePkg {
  constructor() {
    super();
  }
}
